import React, { useEffect, useState } from "react";
import './DatePickerControl.css'
import { Typeahead } from "react-bootstrap-typeahead";
import { Form } from "react-bootstrap";

export interface IDatePickerControl {
  name: string;
  onChange(v: any): void;
  value?: Date;
  minDate?: Date;
  maxDate?: Date;
  className?: string;
}
export function DatePickerControl(props:IDatePickerControl) {
    const monthOptions = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    const [dayOptions, setDayOptions] = useState<any[]>([]);
    const [day, setDay] = useState<any[]>([]);
    const [month, setMonth] = useState<any[]>([]);
    const [year, setYear] = useState<string>('');
    const [validDate, setValidDate] = useState<boolean>(true);
    const [validDay, setValidDay] = useState<boolean>(true);

    // Onload effect to set defaults if a value was passed in
    useEffect(() => {
        if (props.value) {
            setDay([props.value.getDate().toString()]);
            setMonth([monthOptions[props.value.getMonth()]]);
            setYear(props.value.getFullYear().toString());
        }
    }, []);

    // Effect to set the valid number of days
    useEffect(() => {
        let monthNo = 1;
        let yearNo = 1990;
        if (month?.length) {
            monthNo = monthOptions.indexOf(month[0]) + 1;
        }
        if (!!year && !isNaN(+year)) {
            yearNo = +year;
        }
        let daysInMonth = new Date(yearNo, monthNo, 0).getDate();
        //@ts-ignore
        setDayOptions([...Array(daysInMonth).keys().map((x) => (x+1).toString())]);
    }, [month, year]);

    // Update and Validator effect
    useEffect(() => {
        if (day.length && month.length && !!year) {
            let monthNo = monthOptions.indexOf(month[0]) + 1;
            let mm = ('0'+monthNo).slice(-2);
            let dd = ('0'+day).slice(-2);
            let validDate = isDateValid(`${year}-${mm}-${dd}`); 

            if (validDate && isDayValid()) {
                if (props.maxDate && validDate > props.maxDate) {
                    setValidDate(false);
                } else if (props.minDate && validDate < props.minDate) {
                    setValidDate(false);
                } else {
                    setValidDate(true);
                    props.onChange(validDate)
                }

            } else {
                setValidDate(false);
            }
            setValidDay(isDayValid());
        }

    }, [day, month, year, dayOptions]);

    function isDateValid(dateStr:string) {
        var date = new Date(dateStr);
        //@ts-ignore
        if (isNaN(date)) {
            return undefined;
        }
        return date;
    }

    
    function isDayValid() {
        if (dayOptions.includes(day.toString())) {
            return true;
        }
        return false;
    }

    return (<div className={`form-date-span ${props.className}`}>
            <Typeahead
                id={`${props.name}-day`}
                labelKey="name"
                onChange={setDay}
                options={dayOptions}
                placeholder="dd"
                selected={day}
                className={`dateday hoverborder ${validDate && validDay ? '' : 'error-border'}`}
              />
            <Typeahead
                id={`${props.name}-month`}
                labelKey="name"
                onChange={setMonth}
                options={monthOptions}
                placeholder="mmm"
                selected={month}
                className={`datemonth hoverborder ${validDate || !validDay ? '' : 'error-border'}`}
              />
            <Form.Control
                id={`${props.name}-year`}
                onChange={(e) => setYear(e.target.value)}
                placeholder="yyyy"
                type="text"
                maxLength={4}
                value={year}
                className={`dateyear hoverborder ${validDate || !validDay ? '' : 'error-border'}`}
                onFocus={(e) => e.target.select()}
              />
              </div>
        );        
        // <DatePicker className="calendar" ariaLabel="Select a date" strings={defaultDatePickerStrings} allowTextInput={true}
        //     value={this.props.value} onSelectDate={this.props.onChange} formatDate={this.onFormatDate} parseDateFromString={this.onParseDateFromString} />;

};


function onFormatDate(date?: Date): string {
    return !date ? '' : date.getDate() + '/' + (date.getMonth() + 1) + '/' + (date.getFullYear());
};
